module.exports = __webpack_public_path__ + "static/media/block.76b080db.svg";